import { render, staticRenderFns } from "./DetailPurchase.vue?vue&type=template&id=7e61f4f2&scoped=true&"
import script from "./DetailPurchase.vue?vue&type=script&lang=js&"
export * from "./DetailPurchase.vue?vue&type=script&lang=js&"
import style0 from "./DetailPurchase.vue?vue&type=style&index=0&id=7e61f4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e61f4f2",
  null
  
)

export default component.exports